import * as React from "react"
import { APP_DISPLAY_NAME } from "platform-common/index"
import { LinkedinLoginButton } from "../LoginButtons"
import { emailSignupEnabled } from "@web/config/next"
import cs from "classnames"
import { TomboFormAdornment } from "../Forms/TomboFormAdornment"
import RobotLogo from "@web/asset/SVG/RobotLogo"

export interface LoginFormProps {
  title?: string
  subTitle?: string | React.ReactNode
  withPaper?: boolean
  withDisclaimer?: boolean
  withPaperLogo?: boolean
  isLoading?: boolean
  verticalLogo?: boolean
  classes?: {
    root?: string
    button?: string
    title?: string
    subTitle?: string
    adornmentLogo?: string
    paperLogo?: string
  }

  onLinkedInLoginClick?(): void
  onDevLoginClick?(): void
}

export const LoginFormPure: React.FC<LoginFormProps> = ({
  title,
  subTitle,
  withPaper = true,
  withDisclaimer = true,
  withPaperLogo = false,
  verticalLogo = true,
  isLoading,
  classes,
  onDevLoginClick,
  onLinkedInLoginClick,
}) => {
  return (
    <div
      className={cs(
        "tmb-flex tmb-min-h-full tmb-flex-1 tmb-flex-col tmb-items-center tmb-justify-center",
        classes?.root
      )}
    >
      <div className="tmb-w-full tmb-flex tmb-flex-col tmb-justify-center tmb-items-center">
        <div className="sm:tmb-mx-auto sm:tmb-w-full tmb-flex tmb-flex-col">
          <TomboFormAdornment
            title={title || `Welcome to ${APP_DISPLAY_NAME}`}
            subtitle={subTitle}
            isVertical={verticalLogo}
            className="!tmb-w-[unset]"
            classes={{
              title: cs("!tmb-text-3xl tmb-font-bold tmb-font-sans !tmb-mt-3 !tmb-mb-0", classes?.title),
              subTitle: cs("tmb-font-sans !tmb-text-lg tmb-mb-0 tmb-mt-3 !tmb-font-bold", classes?.subTitle),
              logo: cs("tmb-w-20 tmb-h-auto", classes?.adornmentLogo),
            }}
          />
        </div>

        <div className="tmb-max-w-md tmb-w-full">
          <div
            className={cs(
              "tmb-bg-white tmb-px-12 tmb-pt-10 tmb-pb-6 tmb-shadow tmb-rounded-lg tmb-mt-5 tmb-flex tmb-flex-col tmb-gap-2",
              {
                ["!tmb-p-0 tmb-shadow-none !tmb-bg-transparent"]: !withPaper,
              }
            )}
          >
            {withPaperLogo && <RobotLogo className={classes?.paperLogo} />}

            <LinkedinLoginButton isLoading={isLoading} onClick={onLinkedInLoginClick} className={classes?.button} />

            {emailSignupEnabled ? (
              <button
                onClick={onDevLoginClick}
                className="tmb-bg-transparent tmb-border-none tmb-font-sans tmb-mx-auto tmb-p-0 tmb-h-fit -tmb-mb-4 tmb-mt-3 tmb-text-lg tmb-underline tmb-cursor-pointer tmb-w-full"
              >
                Dev Login
              </button>
            ) : null}
          </div>

          {withDisclaimer && (
            <span className="tmb-text-gray tmb-font-sans tmb-flex tmb-mt-3">
              <span className="tmb-text-[32px] tmb-text-pink-400">*</span>
              <span className="tmb-text-lg tmb-ml-2 tmb-text-gray-500">
                {APP_DISPLAY_NAME}™ currently works only with LinkedIn
              </span>
            </span>
          )}
        </div>
      </div>
    </div>
  )
}
